import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DonationCardComponent } from './donation-card.component';
import { DonationCardVM } from '../../../types/donations-feed/models';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'don-donations-list',
    imports: [CommonModule, DonationCardComponent, TranslateModule],
    templateUrl: './donations-list.component.html',
    styleUrls: ['./donations-list.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DonationsListComponent {
  @Input() vms: DonationCardVM[] = [];
  @Input() donorsCount = 0;
  @Output() like = new EventEmitter<string>();
  @Output() share = new EventEmitter<string>();
}
